import React, { useState } from "react";
import className from "../style.module.scss";

interface DevMenuProps {
  showGrid: boolean;
  setShowGrid: (show: boolean) => void;
  devView: boolean;
  setDevView: (show: boolean) => void;
  showAnimationHighlight: boolean;
  setShowAnimationHighlight: (show: boolean) => void;
}

export function DevMenu({
  showGrid,
  setShowGrid,
  devView,
  setDevView,
  showAnimationHighlight,
  setShowAnimationHighlight,
}: DevMenuProps) {
  const [devMenuOpen, setDevMenuOpen] = useState(false);

  return (
    <div className={className.devMenu}>
      <button
        className={className.devMenuToggle}
        onClick={() => setDevMenuOpen(!devMenuOpen)}
        aria-label="Toggle dev menu"
      >
        ☰
      </button>
      {devMenuOpen && (
        <div className={className.devMenuPanel}>
          <label className={className.devMenuOption}>
            <input
              type="checkbox"
              checked={showGrid}
              onChange={(e) => setShowGrid(e.target.checked)}
            />
            <span>Show grid</span>
          </label>
          <label className={className.devMenuOption}>
            <input
              type="checkbox"
              checked={devView}
              onChange={(e) => setDevView(e.target.checked)}
            />
            <span>Dev view</span>
          </label>
          <label className={className.devMenuOption}>
            <input
              type="checkbox"
              checked={showAnimationHighlight}
              onChange={(e) => setShowAnimationHighlight(e.target.checked)}
            />
            <span>ID Anims</span>
          </label>
        </div>
      )}
    </div>
  );
}
